const linesOfBusiness = [
  {key: 'bop', name: 'Business Owners'},
  {key: 'personal_home_auto', name: 'Personal Home & Auto'},
  {key: 'excess_umbrella', name: 'Umbrella & Excess'},
  {key: 'commercial_auto', name: 'Commercial Auto'},
  {key: 'workers_compensation', name: 'Workers Compensation'},
  {key: 'cyber', name: 'Cyber'},
];

export default linesOfBusiness;
